export const FORGOT_PASSWORD_EMAIL_KEY = 'email';
export default { FORGOT_PASSWORD_EMAIL_KEY };
